export type Countdown = {
  days: number,
  hours: number,
  minutes: number,
  seconds: number
}

type CountdownState = {
  timer?: ReturnType<typeof setTimeout>
}

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const CountdownState: CountdownState = {
  timer: undefined
}

export function countdown(
  target: Date,
  onTick: (countdown: Countdown) => void
): () => void {
  clearTimeout(CountdownState.timer);
  onTick(getDistancesToDate(target));
  CountdownState.timer = setTimeout(() => countdown(target, onTick), 1000);
  return () => {
    clearTimeout(CountdownState.timer);
    CountdownState.timer = undefined;
  };
}

function getDistancesToDate(target: Date): Countdown {
  const distance = new Date(target).getTime() - Date.now();
  const days = Math.floor(distance / DAY);
  const hours = Math.floor((distance % DAY) / HOUR);
  const minutes = Math.floor((distance % HOUR) / MINUTE);
  const seconds = Math.floor((distance % MINUTE) / SECOND);
  return { days, hours, minutes, seconds };
}
